

<template>
    <div class="date-tab">
        <div class="date-tab__chips">
            <div
                :class="['date-tab__chips-chip', { 'date-tab__chips-chip--active': item.active }]"
                v-for="(item, index) in tabs"
                :key="index"
                @click="$emit('setTab', index)"
            >
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExtractTabs',
    emits: ['setTab'],
    props: {
        tabs: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang='scss' scoped>
.date-tab {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 12px;
    &__chips {
        display: flex;
        flex-direction: row;
        border-radius: 5px;
        background: #f4f4f4;
        color: #707070;
        padding: 2px;

        &-chip {
            font-size: 13px;
            padding: 4px 12px;
            &--active {
                display: flex;
                align-items: center;
                font-size: 13px;
                border-radius: 5px;
                padding: 4px 12px;
                background: #fff;
                box-shadow: 0px 3px 6px #00000029;
            }
            &:hover {
                cursor: pointer;
                background: #f4f4f4;
                filter: brightness(0.8);
                transition: all 0.2s ease-in-out;
                border-radius: 5px;
            }
        }
    }
}
</style>